import React, { useState } from "react";

const EventCard = ({ event }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <div className="w-full relative group">
        <img
          src={event?.image}
          alt={event?.title}
          className="rounded-md shadow-[0_0_14px_8px_#22beff] sm:h-[17rem]"
        />

        <div className="w-full h-full absolute top-0 left-0 bg-white rounded-md p-4 opacity-0 group-hover:opacity-100 transition-opacity">
          <h1 className="text-xl font-semibold truncate">{event?.title}</h1>
          <div className="sm:max-h-[10.5rem] max-h-[8.7rem] overflow-hidden pb-2 text-justify text-base mb-4">
            <p>{event?.description}</p>
          </div>
          <button
            className="w-full py-1 bg-[#22BEFF] rounded border border-transparent text-white cursor-pointer hover:border-[#22BEFF] hover:text-[#22BEFF] hover:bg-transparent hover:font-semibold"
            onClick={() => setIsOpen(true)}
          >
            Read More
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-2xl ">
            <h2 className="text-xl font-semibold mb-4">{event?.title}</h2>
            <div className="grid sm:grid-cols-3 grid-cols-2 gap-4">
              {event?.gellary_image.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt="gellary_image"
                  className="rounded-md"
                />
              ))}
            </div>
            <div className="mb-4 mt-2 max-h-[25rem] overflow-auto">
              <p className="mb-4 mt-2">
                {event?.description}
              </p>
            </div>
            <div className="flex justify-end">
              <button
                onClick={() => setIsOpen(false)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 cursor-pointer"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventCard;
